import React from "react";
import styled from "styled-components";
import { BookmarkOutlineIcon } from "../svgs";
import { StyledText } from "../common";

const SavedMotivationCard = ({ color, text, onClick, onBookmarkClick }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: `1px solid ${color}`,
        borderRadius: 10,
        marginInline: 15,
        marginTop: 10,
        marginBottom: 10,
        paddingInline: 10,
      }}
      onClick={onClick}
    >
      <StyledText>{text}</StyledText>
      <IconContainer onClick={onBookmarkClick}>
        <BookmarkOutlineIcon />
      </IconContainer>
    </div>
  );
};

const IconContainer = styled.div`
  border: 1px solid #d9d9d9;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  margin-left: 10px;
`;

export default SavedMotivationCard;
